export default function EquipmentIcon() {
  return (
    <img src="/icon/equipment_icon.png" alt="" className="h-[36px] w-[36px]" />
  )
}
